const MyCardsCardsTypeSetPage = () => {
  return null;
};

export default MyCardsCardsTypeSetPage;
